module.exports = __webpack_public_path__ + "img/2018-attendance.88c09e78.jpg";